import type { Course, OfficeHost } from "@/core/types";
import { excelKurs } from "./excel";
import { powerPointKurs } from "./powerpoint";
import { wordGrundlagenkurs } from "./word";

/** Alle verfügbaren Kurse. Neue Kurse werden hier registriert. */
export const courses: Course[] = [wordGrundlagenkurs, excelKurs, powerPointKurs];

export function coursesForHost(host: OfficeHost | null): Course[] {
  if (!host) return courses;
  return courses.filter((course) => course.host === host);
}

export function findCourse(courseId: string): Course | undefined {
  return courses.find((course) => course.id === courseId);
}
